import { render } from "./ChanceBoard.vue?vue&type=template&id=33c6b8ee&scoped=true"
import script from "./ChanceBoard.vue?vue&type=script&lang=js"
export * from "./ChanceBoard.vue?vue&type=script&lang=js"

import "./ChanceBoard.vue?vue&type=style&index=0&id=33c6b8ee&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c6b8ee"]])

export default __exports__